import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { CORE_PROMISE, heroPillars, PRICE } from '../../data/salesContent';
export function HeroSection() {
  return <header className="bg-ink px-5 pb-20 pt-12 md:pb-28 md:pt-16" data-id="element-73" data-mp="219b9vetkbp88">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[1.05fr_1fr]" data-id="element-74" data-mp="1x915g6lf56vh">
        <div className="text-center lg:text-left" data-id="element-75" data-mp="1s9o8gt0u2jf6">
          <p className="inline-block rounded-full border border-gold/40 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-gold md:text-sm" data-id="element-76" data-mp="1sag0xuz4w118">
            Sistema profesional para instructores
          </p>
          <p className="mt-6 font-display text-base font-extrabold uppercase tracking-[0.15em] text-neutral-300 md:text-lg" data-id="element-77" data-mp="1ik4mhehtq9g3">
            Sistema Primeros Auxilios para Instructores™
          </p>
          <h1 className="mt-4 font-display text-4xl font-black leading-[1.1] text-cream md:text-6xl" data-id="element-78" data-mp="19idice2xmaoc">
            Dejá de preparar cada capacitación de primeros auxilios <span className="text-gold" data-id="element-79" data-mp="31nvzvi49jamn">desde cero.</span>
          </h1>
          <p className="mt-6 text-xl leading-relaxed text-cream md:text-2xl" data-id="element-80" data-mp="36euk2ssdgsv6">
            Tené organizado qué enseñar, cómo enseñarlo, cómo hacerlo practicar y cómo evaluar a tus alumnos.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-neutral-400 md:text-xl" data-id="element-81" data-mp="2wp1atyfpcpu3">
            Un sistema digital compuesto por <strong className="text-cream" data-id="element-82" data-mp="3ke41fvsbdt0q">3 volúmenes + 5 bonos prácticos</strong> diseñado para
            ayudarte a preparar capacitaciones más claras, organizadas y profesionales sin pasar horas buscando información, creando
            actividades, inventando escenarios o armando evaluaciones desde cero.
          </p>

          <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-3 lg:justify-start" data-id="element-83" data-mp="3gbpfv3x9gf5r">
            {heroPillars.map(({
            label,
            icon: Icon
          }) => <li key={label} className="flex items-center gap-2 text-sm font-semibold text-neutral-200 md:text-base" data-id="element-84" data-mp="24xlnu3a8h13c">
                <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-85" data-mp="ahwpeeejwsax" />
                {label}
              </li>)}
          </ul>
        </div>

        <ProductImage className="mx-auto w-full max-w-2xl" data-id="element-86" data-mp="5kn0r0yzkko5" />
      </div>

      <div className="mx-auto mt-14 flex max-w-2xl flex-col items-center text-center" data-id="element-87" data-mp="qagiopor5bc">
        <p className="font-display text-xl font-extrabold uppercase tracking-wide text-gold md:text-2xl" data-id="element-88" data-mp="3suuu0ymag9bf">{CORE_PROMISE}</p>
        <div className="my-8 h-px w-full bg-ink-line" aria-hidden="true" data-id="element-89" data-mp="3nxup4r16dclw" />
        <p className="text-base font-bold uppercase tracking-[0.2em] text-neutral-400 md:text-lg" data-id="element-90" data-mp="3iwouuorv9ha9">Hoy por</p>
        <p className="mt-1 font-display text-5xl font-black text-gold md:text-6xl" data-id="element-91" data-mp="3dyvonvqkcn9z">{PRICE}</p>
        <p className="mt-3 text-base text-neutral-300 md:text-lg" data-id="element-92" data-mp="39y3couqb44a0">Pago único · Acceso digital inmediato</p>
        <div className="mt-8 w-full" data-id="element-93" data-mp="1c6gyyahs2ej0">
          <CtaButton note="3 volúmenes + 5 bonos · Acceso inmediato" data-id="element-94" data-mp="185f7ifu3r6rl">Quiero el sistema completo</CtaButton>
        </div>
      </div>
    </header>;
}